module.exports = __webpack_public_path__ + "static/img/xxpl_banner.fdc7963.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xxpl_banner.png
// module id = t8Yk
// module chunks = 0